<button class="btn link-bg-btn" *ngIf="view" type="button" (click)="view ? openInNewTab(): download()" [rlAria]="(view? 'general.view' : 'generla.download') | translate" id="content-privew-view">
	<i class="fa fa-external-link" aria-hidden="true"></i>
    {{(view? 'general.view' : 'general.download') | translate}}
</button>
